import triggerAnalyticsEvent, {
  setAnalyticsDefaults
} from 'helpers/triggerAnalyticsEvent'

export const triggerOnCloseAnalytics = () => {
  setAnalyticsDefaults({ PageKind: 'multiaccount' })
  triggerAnalyticsEvent({
    PageFunction: 'dashboard',
    PageKind: 'multiaccount'
  })
}
